
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import ObjectInfoValues from './ObjectInfoValues';
import ObjectInfoTitle from './ObjectInfoTitle';
import ObjectInfoParcely from './ObjectInfoParcely';
import ObjectInfoTelesa from './ObjectInfoTelesa';

const classNames = mergeStyleSets({
    root: {
    }
});

const ObjectInfoOpsubDetail = (props) => {
    return (
        <React.Fragment>
            <ObjectInfoTitle title="VLASTNÍK" />
            <ObjectInfoValues items={[
                {
                    title: 'Jméno/Název',
                    value: props.opsub.name
                },
                {
                    title: 'Adresa',
                    value: props.opsub.address
                },
                {
                    title: 'RČ/IČO',
                    value: props.opsub.rcico
                },
                {
                    title: 'Typ',
                    value: props.opsub.opsub_type
                }
            ]}/>
        </React.Fragment>
    );
}

const ObjectInfoOpsub = (props) => {
    return (
        <div className={classNames.root}>
            <Stack tokens={{childrenGap: 16}}>
                <Stack.Item>
                    <ObjectInfoOpsubDetail opsub={props.info.params} />
                </Stack.Item>
                <Stack.Item grow>
                    <ObjectInfoTelesa
                        tel={props.info.tel}
                    />
                </Stack.Item>
                <Stack.Item grow>
                    <ObjectInfoParcely
                        title="PARCELY"
                        parc={props.info.parc}
                    />
                </Stack.Item>
            </Stack>
        </div>
    );
}

export default ObjectInfoOpsub;
